import React from 'react';
import { boundingExtent } from 'ol/extent';
import { fromLonLat } from 'ol/proj';
import Map from 'ol/Map';
import { OSM } from 'ol/source';
import PropTypes from 'prop-types';
import View from 'ol/View';
import { Tile as TileLayer } from 'ol/layer';
import * as olInteraction from 'ol/interaction';

import { addLayerToMap } from 'utils/map/map';
import { createLayer } from 'utils/map/layers';
import { addApprovedAreasToLayer } from 'components/approvedAreas/utils/main';
import useStyles from './OrganizationMapRenderUseStyles';

const OrganizationMapRender = props => {
  const { organization } = props;
  const classes = useStyles();
  // created Array, because that is what function setApprovedAreasToLayer accepts
  const foundAreaArray = [];
  foundAreaArray.push(organization);

  const tileLayer = React.useRef(
    new TileLayer({
      source: new OSM(),
    })
  );
  const map = React.useRef({});
  const drawingsLayer = React.useRef(null);

  const createMapWithApprovedArea = () => {
    drawingsLayer.current = createLayer('drawingsLayer');
    map.current = new Map({
      layers: [tileLayer.current],
      target: `mapToDraw${organization.uid.slice(3, 8)}`,
      view: new View({
        zoom: 14,
      }),
      interactions: olInteraction.defaults({
        mouseWheelZoom: false,
        doubleClickZoom: false,
        keyboardZoom: false,
      }),
    });
    map.current.getView().fit(boundingExtent(getDataForExtent()), {
      padding: [10, 10, 10, 10],
    });
    addLayerToMap(map.current, drawingsLayer.current);
    addApprovedAreasToLayer(drawingsLayer.current, foundAreaArray);
    return map;
  };

  React.useEffect(() => {
    createMapWithApprovedArea();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDataForExtent = () => {
    const extentArray = [];
    for (const exactPoints of organization.geojson.coordinates[0]) {
      extentArray.push(fromLonLat(exactPoints));
    }

    return extentArray;
  };

  return (
    <div
      className={classes.OrganizationMap}
      id={`mapToDraw${organization.uid.slice(3, 8)}`}
    ></div>
  );
};

OrganizationMapRender.propTypes = {
  organization: PropTypes.object.isRequired,
};

export default OrganizationMapRender;
